import { useForm } from "@/src/provider/Form/FormProvider";
import Grid from "@mui/material/Grid";
import Group from "@/src/components/Wizard/Group";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import ValidatorDateField from "@/src/components/FormFields/ValidatorDateField";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import { dateFieldDefault, pastDateDefault, requiredValidator } from "@/src/services/validationRules";
import wizardStyle from "@/src/components/Form/wizardStyle";

export default function ClientClaimedData() {
  const { values } = useForm();

  return (
    <>
      <Grid size={12}>
        <Group
          type="radio"
          name="clientHasAlreadyClaimed"
          question="Haben Sie bereits schriftlich eine Forderung gestellt?"
          options={[
            {
              labelText: "Ja, ich habe bereits etwas eingefordert.",
              labelIcon: <CheckIcon />,
              labelIconActive: <CheckIcon active />,
              value: "yes",
            },
            {
              labelText: "Nein, ich habe bisher nichts eingefordert.",
              labelIcon: <CrossIcon />,
              labelIconActive: <CrossIcon active />,
              value: "no",
            },
          ]}
          validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
        />
      </Grid>
      {values.clientHasAlreadyClaimed === "yes" && (
        <>
          <Grid sx={wizardStyle.gridTopSpaced} size={12}>
            <FormLegend>Wann haben Sie schriftlich etwas eingefordert?</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorDateField
              name="claimedDateClient"
              label="Datum des Forderungsschreibens"
              validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault, pastDateDefault]}
            />
          </Grid>
          <Grid size={12}>
            <ValidatorDateField
              name="claimedDeadlineClient"
              label="Frist im Forderungsschreiben "
              validators={[dateFieldDefault]}
              helperText={"Wenn Sie keine Frist gesetzt haben, dann lassen Sie das Feld einfach leer."}
            />
          </Grid>
        </>
      )}
    </>
  );
}
